<template>
  <div class="developer-list">
    <div
      class="developer-list__item"
      v-for="(item, index) in list"
    >
      <v-autocomplete
        id="developer"
        item-value="id"
        item-text="transName"
        :items="developers"
        :value="item.id"
        @change="changeDeveloper(index, $event)"
        input="transName"
        outlined
        rounded
        dense
      />
      <div
        class="developer-list__item__btn main"
        v-if="item.is_main || item.isMain"
      >
        Главный
      </div>
      <div
        class="developer-list__item__btn"
        v-if="!item.is_main && !item.isMain"
        @click="changeIsMain(index)"
      >
        Назначить главным
      </div>
      <div
        class=""
        @click="removeDeveloper(index)"
      >
        Удалить
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "DeveloperList",
    props: {
      list: {
        type: Array,
        required: true
      },
      developers: {
        type: Array,
        required: true
      }
    },

    methods: {
      changeDeveloper(index, event) {
        this.$emit('change-developer',index, event)
      },
      changeIsMain (index) {
        this.$emit('change-is-main',index)
      },
      removeDeveloper(index) {
        this.$emit('remove-developer', index)
      }
    }
  }
</script>
<style lang="scss">
  .developer-list {
    width: 100%;

    &__item {
      padding: 10px 0;
      display: flex;
      height: 60px;
      align-items: center;

      .v-input {
        max-width: 600px;
      }

      &__btn {
        width: 200px;
        margin: 0 10px;
        background-color: #cdcdcd;
        text-align: center;
        border-radius: 10px;
        font-size: 14px;
        cursor: pointer;
      }

      .main {
        color: #fff;
        background-color: #b12a2f;
        cursor: default;
      }
    }
  }
</style>
